<template>
    <div class="icons-container">
        
        <a
            v-for="(value, key, i) in socials"
            :href="value"
            :class="[(i !==0 && i !== (Object.keys(socials).length - 1)) ? 'margin' : false]"
            :key="key"
            alt="#"
        >
            <img :class="['icon', key]" :src="require(`@/assets/img/icons/${key}.svg`)" alt="#" />
        </a>

    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: "VIcons",
    props: {
    },
    computed: {
        ...mapState('proprietary', [
            'socials'
        ])
    }
};
</script>

<style scoped lang="scss">

.icons-container { 
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    a{cursor: pointer}
}

.icon {
    width: 20px;
    height: 20px;
    padding: 10px 13px;
    border-radius: 3px;
}

.facebook { background-color: #3b5998; }
.linkedin { background-color: #0077b5; }
.youtube { background-color: #cd2221; }
.margin{ margin: 0 10px; }
</style>